import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import Chart from "react-google-charts";
import { makeStyles } from "@material-ui/core";
import { Stack } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import ArticleIcon from "@mui/icons-material/Article";
import PercentIcon from "@mui/icons-material/Percent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { summaryRecord } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/DashboardScreenStyle";
//import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
//import Button from "components/CustomButtons/VivoleoButton.js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function FinanceDashboardScreen(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const recordSummary = useSelector((state) => state.recordSummary);
  const { loading, summary, error } = recordSummary;
  let { category } = useParams();

  const dispatch = useDispatch();

  const toYearlyReport = () => {};
  useEffect(() => {
    dispatch(summaryRecord());
  }, [dispatch]);
  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    return `/searchrecord/category/${filterCategory}`;
  };

  //console.log("summary-totalAmount: " + JSON.stringify(summary.totalAmount));

  return (
    <div>
      <div className={classes.space30}> </div>
      <div className={classes.textCenter}>
        <h1>Finance Record Dashboard</h1>
      </div>
      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
      >
        <Button
          className="medium"
          startIcon={<CategoryIcon className={classes.btnColor} />}
          onClick={() => navigate("/listcategory")}
        >
          {[t("wordslib.category"), t("wordslib.management")]}
        </Button>

        <Button
          vivoblue
          startIcon={<PercentIcon className={classes.btnColor} />}
          onClick={() => navigate("/edittax")}
        >
          {[t("wordslib.tax"), t("wordslib.management")]}
        </Button>

        <Button
          className="medium"
          startIcon={<ArticleIcon className={classes.btnColor} />}
          onClick={() => navigate("/generatereport")}
        >
          {[t("wordslib.generate"), t("wordslib.report")]}
        </Button>
      </Stack>

      {loading ? (
        <LoadingBox />
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <GridContainer justify="center" className={classes.contentText}>
            <GridItem xs={12} sm={12} md={12} className={classes.topSpace}>
              <Link to="/recordlist">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 400 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">
                          {[t("wordslib.total"), t("wordslib.record")]}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {[t("wordslib.total"), t("wordslib.expense")]}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell align="left">
                          {summary.records[0]
                            ? summary.records[0].numRecords
                            : 0}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          $
                          {summary.records[0]
                            ? summary.records[0].totalExpense.toFixed(2)
                            : 0}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Link>
            </GridItem>
          </GridContainer>
          <div className="row summary"></div>
          <div className={classes.space30}> </div>
          {summary.totalAmount.length === 0 ? (
            <MessageBox>No Expense</MessageBox>
          ) : (
            <div>
              {summary.totalAmount[0].description} Period:{" "}
              {summary.totalAmount[0].fromdate} ~{" "}
              {summary.totalAmount[0].todate}
            </div>
          )}
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 400 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left">
                    {t("wordslib.category")}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {t("wordslib.subtotal")}&nbsp;($CAD)
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    NET Amounts&nbsp;($CAD)
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    HST Amount&nbsp;($CAD)
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summary.totalAmount.length === 0 ? (
                  <MessageBox>No Expense</MessageBox>
                ) : (
                  summary.totalAmount.map((subtotal, _id) => (
                    <StyledTableRow key={subtotal._id}>
                      <StyledTableCell align="left">
                        <Link to={getFilterUrl({ category: subtotal._id })}>
                          {subtotal._id}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        ${subtotal.totalExpense.toFixed(2)}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <div>
            <Link to="/showyearlyreport">
              <button type="button" className="primary block">
                Show Yearly Report
              </button>
            </Link>
          </div>
          <div>
            <Link to="/searchrecord">
              <button type="button" className="primary block">
                Search Record
              </button>
            </Link>
          </div>
          <div>
            <div>
              <h2>Expense </h2>
              {summary.dailyRecords.length === 0 ? (
                <MessageBox>No Expense</MessageBox>
              ) : (
                <Chart
                  width="100%"
                  height="400px"
                  chartType="AreaChart"
                  loader={<div>Loading Chart</div>}
                  data={[
                    ["Date", "TotalExpense"],
                    ...summary.dailyRecords.map((x) => [
                      x._id,
                      x.invoiceamount,
                    ]),
                  ]}
                ></Chart>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
